// extracted by mini-css-extract-plugin
export default {"suggestions-heading":"suggestions-heading--LqkWG","suggestions":"suggestions--y7f6C","suggestions__suggestion-wrapper":"suggestions__suggestion-wrapper--pOXqV"};